import DispatcherPdf from './dispatcher.pdf';
import DispatcherApp from './dispatcher.app';

let loadedModule;
if (global.JDS_PDF) {
  loadedModule = DispatcherPdf;
} else {
  loadedModule = DispatcherApp;
}

export default loadedModule;
